export enum ShowcaseAggregatePathEnum {
  aggregate = 'aggregate/v2/catalog/courses',
  aggregateAuth = 'aggregate/v2/auth/catalog/courses',
  aggregateAuthWithToken = 'aggregate/v1/catalog/courses/token',
}
